module.exports = __webpack_public_path__ + "static/media/logo_yupoints_w.ecd4ffcf.png";